import { render, staticRenderFns } from "./VirementSection.vue?vue&type=template&id=2d5b7d30&scoped=true&"
import script from "./VirementSection.vue?vue&type=script&lang=js&"
export * from "./VirementSection.vue?vue&type=script&lang=js&"
import style0 from "./VirementSection.vue?vue&type=style&index=0&id=2d5b7d30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5b7d30",
  null
  
)

export default component.exports